module.exports = __webpack_public_path__ + "components/country-flag/static/rw-1772e3ca75ca62a8774748235d6148f4.svg";